// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__V35e3","colBig":"styles_colBig__khVn5","colSmall":"styles_colSmall__3jVal"};